// extracted by mini-css-extract-plugin
export default {"formSubmit":"index_formSubmit_qDdDP","formSubmitSave":"index_formSubmitSave_sNSfC","formSubmitButton":"index_formSubmitButton_eRr8j"};